/**
 * ProjectIcon — the mark for a project, in one place.
 *
 * A plain folder was the first cut and it was wrong: a folder means "somewhere
 * files are kept", which is the least interesting thing about a project, and it
 * is the same glyph every file browser on earth uses. A project here is a
 * *board a group works on together* — so the mark is a board with work on it:
 * one wide lane and two stacked cards, the shape you recognise as a workspace
 * rather than as storage.
 *
 * Deliberately NOT a briefcase (reads as "company"), and NOT columns of bars
 * (collides with the Insights icon at rail size).
 *
 * Rendered from a single source so the sidebar, the list cards, the invitation
 * card and the chat strip can never drift into three different project glyphs.
 */

export interface ProjectIconProps {
  /** Stroke weight. The rail uses 2; smaller inline uses want ~1.7. */
  strokeWidth?: number;
  className?: string;
}

export function ProjectIcon({ strokeWidth = 1.8, className }: ProjectIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* The board */}
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      {/* Its header rule — what makes it read as a board and not a plain card */}
      <path d="M3 8.5h18" />
      {/* The work on it: one lane, two cards */}
      <path d="M7 12.5h4.5" />
      <path d="M7 16h3" />
      <path d="M15 12.5h2" />
      <path d="M15 16h2" />
    </svg>
  );
}

export default ProjectIcon;
